import React from 'react';
import Link, { LinkProps } from 'sensortower-components/src/base-components/Link';
import BaseMedia, { MediaProps as BaseMediaProps } from 'sensortower-components/src/base-components/Media';

export interface MediaProps extends BaseMediaProps {
  link?: LinkProps;
}

export const Media = ({ link, ...rest }: MediaProps) => {
  const media = <BaseMedia {...rest} disableInlineSVG />;
  if (link) {
    return (
      <Link {...(link as any)} noLinkStyle>
        {media}
      </Link>
    );
  }
  return <BaseMedia {...rest} />;
};

export default Media;
